module.exports = __webpack_public_path__ + "img/img37.9ec7bf57.svg";